import { StateCreator } from 'zustand';

export interface ThemeSlice {
  lightThemeColors: Record<string, string>;
  setLightThemeColors: (theme: Record<string, string>) => void;
  darkThemeColors: Record<string, string>;
  setDarkThemeColors: (theme: Record<string, string>) => void;
  hexColors: Record<string, string>;
  setHexColors: (theme: Record<string, string>) => void;
  themeMode: string;
  setThemeMode: (themeMode: string) => void;
}

const lightThemeColors = {
  '--background': '0 0% 100%', // white background
  '--foreground': '24 20% 20%', // Dark brown text
  '--card': '0 0% 100%',
  '--card-foreground': '24 20% 20%',
  '--popover': '0 0% 100%',
  '--popover-foreground': '24 20% 20%',
  '--primary': '30 90% 55%',
  '--primary-foreground': '0 0% 100%', // white text on primary
  '--secondary': '39 100% 92%',
  '--secondary-foreground': '30 40% 30%', // mid-tone brown
  // '--muted': '39 100% 92%', // pale orange tint
  '--muted': '0 0% 97%',
  '--muted-foreground': '30 20% 40%', // soft brown
  '--accent': '28 100% 85%', // light peach accent
  '--accent-foreground': '24 20% 20%',
  '--success': '145 50% 40%', // green for success
  '--success-foreground': '0 0% 100%',
  '--destructive': '0 85% 55%', // red for errors
  '--destructive-foreground': '0 0% 100%',
  '--border': '30 30% 85%', // warm beige border
  '--input': '30 30% 85%', // input background
  '--ring': '30 90% 55%', // match primary
  '--radius': '0.5rem',
};


//  dark blue
const darkThemeColors = {
  '--background': '222.2 84% 4.9%',
  '--foreground': '210 40% 98%',
  '--card': '222.2 84% 4.9%',
  '--card-foreground': '210 40% 98%',
  '--popover': '222.2 84% 4.9%',
  '--popover-foreground': '0 0% 100%',
  '--primary': '198 100% 39%',
  '--primary-foreground': '210 40% 98%',
  '--secondary': '199 76% 18%',
  '--secondary-foreground': '210 40% 98%',
  '--muted': '217.2 32.6% 17.5%',
  '--muted-foreground': '215 20.2% 65.1%',
  '--accent': '217.2 32.6% 17.5%',
  '--accent-foreground': '210 40% 98%',
  '--success': '161 94% 30%',
  '--success-foreground': '210 40% 98%',
  '--destructive': '0 84.2% 60.2%',
  '--destructive-foreground': '0 0% 100%',
  '--border': '217.2 32.6% 17.5%',
  '--input': '215 19% 35%',
  '--ring': '197 89% 45%',
  '--radius': '0.5rem',
};

// Dark black
// const darkThemeColors = {
//   '--background': '222 10% 4%',               // close to rgb(9,10,12)
//   '--foreground': '0 0% 90%',                 // soft light gray for text
//   '--card': '222 10% 6%',                     // just above background
//   '--card-foreground': '0 0% 90%',
//   '--popover': '222 10% 8%',
//   '--popover-foreground': '0 0% 95%',
//   '--primary': '30 3% 40%',                   // muted, warm-neutral brownish
//   '--primary-foreground': '0 0% 98%',
//   '--secondary': '222 10% 12%',               // deep neutral
//   '--secondary-foreground': '0 0% 85%',
//   '--muted': '222 8% 10%',                    // soft dark gray
//   '--muted-foreground': '0 0% 60%',           // medium gray text
//   '--accent': '30 5% 15%',                    // dark earthy accent
//   '--accent-foreground': '0 0% 95%',
//   '--success': '141 20% 35%',                 // calm, muted green
//   '--success-foreground': '0 0% 98%',
//   '--destructive': '0 60% 40%',               // toned down dark red
//   '--destructive-foreground': '0 0% 100%',
//   '--border': '222 10% 14%',
//   '--input': '222 10% 16%',
//   '--ring': '30 3% 40%',                      // matches primary
//   '--radius': '0.5rem',
// };

const hexColors = {
  primaryLight: '',
  secondaryLight: '',
  primaryDark: '',
  secondaryDark: '',
};

export const themeSlice: StateCreator<ThemeSlice> = (set) => ({
  lightThemeColors,
  setLightThemeColors: (themeColors: Record<string, string>) =>
    set((state) => ({
      lightThemeColors: { ...state.lightThemeColors, ...themeColors },
    })),
  darkThemeColors,
  setDarkThemeColors: (themeColors: Record<string, string>) =>
    set((state) => ({
      darkThemeColors: { ...state.darkThemeColors, ...themeColors },
    })),
  hexColors,
  setHexColors: (themeColors: Record<string, string>) =>
    set((state) => ({ hexColors: { ...state.hexColors, ...themeColors } })),
  themeMode: 'auto',
  setThemeMode: (themeMode: string) => set(() => ({ themeMode })),
});
